const DefaultPartnersList = [
  { name: 'BBC World Service', logo: 'static/images/partner-logos/bbc-world-service.svg' },
  { name: 'Africa Media Festival', logo: 'static/images/partner-logos/amf.svg' },
  { name: 'Podcast Movement', logo: 'static/images/partner-logos/podcast-movement.svg' },
  { name: 'The Guardian', logo: 'static/images/partner-logos/guardian.svg' },
  { name: 'Apple Podcasts', logo: 'static/images/partner-logos/apple-podcasts.svg' },
  { name: 'Forbes Africa', logo: 'static/images/partner-logos/forbes-africa.svg' },
  { name: 'Podnews', logo: 'static/images/partner-logos/podnews.svg' },
  { name: 'Advertising Week Africa', logo: 'static/images/partner-logos/awa.svg' },
]

export default DefaultPartnersList



// WEBPACK FOOTER //
// ./src/components/reused-components/partnersBar/DefaultPartnersList.js